import React from 'react';
import AssumptionValueDisplay from './AssumptionValueDisplay';
import AssumptionEditor from './AssumptionEditor';

const Assumption = {
  // components that do the actual work
  designer: () => <div />,
  display: AssumptionValueDisplay,
  editor: AssumptionEditor,

  getPropValue(elementProp) {
    const prop = elementProp.toJSON();
    const { hidden, description } = prop;
    if (hidden) {
      return {
        hidden,
        description,
      };
    }
    return null;
  }
};

export default Assumption;




// WEBPACK FOOTER //
// ./src/components/types/Assumption/Assumption.js